import React from 'react';
import PropTypes from 'prop-types';
import {performSearch} from 'src/utils/router';
import classNames from 'classnames';
import i18n from 'i18next';

class SearchInput extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    groupCode: PropTypes.number,
    handleClick: PropTypes.func,
    icon: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.string,
  }

  static defaultProps = {
    className: 'className',
    groupCode: null,
    handleClick: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
    };
  }

  onSearch = (event) => {
    event.preventDefault();
    performSearch(this.state.searchQuery, this.props.groupCode || 'all');
  }

  onChange = (event) => {
    this.setState({searchQuery: event.target.value });
  }

  render() {
    const {className, handleClick, icon, size} = this.props;
    const containerClass = classNames({
      [className]: true,
    });
    const inputClass = classNames({
      'search-input': true,
      [`search-input__${size}`]: size,
    });
    const placeholder = this.props.placeholder || i18n.t('Search');

    return <form className={containerClass} onSubmit={this.onSearch}>
      <input
        className={inputClass}
        placeholder={placeholder}
        type="text"
        value={this.state.searchQuery}
        onChange={this.onChange}
        onClick={handleClick}/>
    </form>;
  }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/inputs/search.js